import { useContext, useMemo } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { Button, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { unarchiveTemplate } from '/providers/templates-api'
import PageWrapper from '/components/page-wrapper'
import Menu from '/components/templates/template-nav-menu'
import HelpText from '/help/template-unarchive'

const TemplateUnarchive = () => {
  const { templateId } = useParams()
  const navigate = useNavigate()
  const { apiSource, apiKey, loadingTemplates, templates, refreshTemplates, processing, setProcessing } = useContext(AppContext)
  const template = useMemo(() => templates.find(item => item.template_id === templateId) ?? null, [templates, templateId])
  if (!loadingTemplates && (!template || !template.archived)) return <Navigate to='/templates' replace />
  const unarchive = async () => {
    setProcessing(true)
    const result = await unarchiveTemplate({ apiSource, apiKey, templateId })
    setProcessing(false)
    if (result?.error || result?.ok === false) return enqueueSnackbar({ message: result?.error?.message ?? 'Unable to unarchive template', variant: 'error' })
    await refreshTemplates()
    enqueueSnackbar({ message: 'Template unarchived', variant: 'success' })
    navigate(`/templates/${templateId}/details`)
  }
  return <PageWrapper title={template ? `Unarchive Template (${template.name})` : 'Unarchive Template'} HelpText={HelpText} heading='Unarchive template' selectedTemplate={template} menu={<Menu template={template} processing={processing} setProcessing={setProcessing} />}>
    <div className='p-5 max-w-2xl flex flex-col gap-5'><Typography variant='h4'>Unarchive template</Typography><Typography>Unarchive <strong>{template?.name}</strong> to make it available for editing and issuing passes again.</Typography><div className='flex gap-3'><Button onClick={() => navigate('/templates')} disabled={processing}>Cancel</Button><Button variant='contained' onClick={unarchive} disabled={processing}>Unarchive template</Button></div></div>
  </PageWrapper>
}

export default TemplateUnarchive
